import { useTranslation, Trans } from 'react-i18next';
import { Typography } from '@dagensmat/carrot/Components';
import { B } from 'utils/fonts';

type SearchResultCountProps = {
  count: number;
  countProducers: number;
};

const SearchResultCount = ({
  count,
  countProducers
}: SearchResultCountProps) => {
  const { t } = useTranslation();

  return (
    <Trans
      t={t}
      i18nKey="consumer:AmountOfProductsFound"
      values={{ count, countProducers }}
      components={{
        P: <Typography variant="paragraphSmall" />,
        B: <B />
      }}
    />
  );
};

export default SearchResultCount;
